import React, { useState } from "react";
import logo from "../assets/user-assets/logo.svg";
import { Link, NavLink } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import { RxCross2 } from "react-icons/rx";

const Navbar = () => {
  const [hamburgerState, setHamburgerState] = useState(false);

  return (
    <div className="mx-3 sm:mx-12">
      <nav className="max-w-[1200px] flex justify-between items-center mx-auto relative">
        <Link to="/" className="flex items-center -ml-3 sm:-ml-6 ">
          <img
            className="h-[60px] sm:h-[80px] object-contain"
            src={logo}
            alt="logo"
          />
          <p className="-ml-5 sm:-ml-6 text-lg sm:text-2xl mt-4 font-normal">
            ahul Bhutaiya
          </p>
        </Link>

        <div className="items-center gap-8 text-xl font-medium hidden lg:flex">
          <NavLink className="transiton-on-nav-items" to="/">
            Home
          </NavLink>
          <NavLink className="transiton-on-nav-items" to="/projects">
            Projects
          </NavLink>
          <NavLink className="transiton-on-nav-items" to="/skills">
            Skills
          </NavLink>
          <NavLink className="transiton-on-nav-items" to="/experience">
            Experience
          </NavLink>
          <NavLink className="transiton-on-nav-items" to="/contact">
            Contact Me
          </NavLink>
        </div>

        {/* hamburger-menu */}
        <div className="flex flex-col items-center gap-3 lg:hidden text-black text-xl mt-4 sm:mt-6 relative transition-for-hamburger">
          {hamburgerState ? (
            <RxCross2 onClick={() => setHamburgerState(!hamburgerState)} />
          ) : (
            <GiHamburgerMenu
              onClick={() => setHamburgerState(!hamburgerState)}
            />
          )}
        </div>
        <div
          className={
            hamburgerState
              ? "h-[12rem] absolute right-0 top-16 flex flex-col items-center gap-4 text-xs font-medium w-[100%]  sm:max-w-[200px] sm:w-[35%] lg:hidden  rounded-lg overflow-hidden navlinks-for-hamburger"
              : "h-0 absolute right-0 top-16 flex flex-col items-center gap-4 text-xs font-medium w-[100%]  sm:max-w-[200px] sm:w-[35%] lg:hidden  rounded-lg overflow-hidden navlinks-for-hamburger"
          }
        >
          <NavLink
            className="mt-3 transiton-on-nav-items"
            to="/"
            onClick={() => setHamburgerState(false)}
          >
            Home
          </NavLink>
          <NavLink
            className="transiton-on-nav-items"
            to="/projects"
            onClick={() => setHamburgerState(false)}
          >
            Projects
          </NavLink>
          <NavLink
            className="transiton-on-nav-items"
            to="/skills"
            onClick={() => setHamburgerState(false)}
          >
            Skills
          </NavLink>
          <NavLink
            className="transiton-on-nav-items"
            to="/experience"
            onClick={() => setHamburgerState(false)}
          >
            Experience
          </NavLink>
          <NavLink
            className="mb-3 transiton-on-nav-items"
            to="/contact"
            onClick={() => setHamburgerState(false)}
          >
            Contact Me
          </NavLink>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
